import { SurveyResponse, SurveyAdminResponse } from "./types";

export const isSurveyAdminResponse = (
  survey: SurveyResponse,
): survey is SurveyAdminResponse => {
  return (
    "invitesCount" in survey &&
    "responsesCount" in survey &&
    "submittedSurveysCount" in survey
  );
};
